export default {
    all: 'Alles',
    manual_processing: 'Handmatige uitbetaling',
    automatic_processing_delay: 'Automatische uitbetaling wachtrij',
    requested: 'Te accorderen',
}
